import React from 'react';
import { ModalWindow } from 'components/modal-window/modal-window';
import { FormCompleteSignUp } from 'components/forms/form-complete-sign-up/form-complete-sign-up';
import { withUser } from 'core/hocs';
import PropTypes from 'prop-types';
import { MODAL_IDS } from '../../../constants';

const CompleteSignUpModalUI = ({
  userData
}) => (
  <ModalWindow
    id={MODAL_IDS.COMPLETE_SIGN_UP}
    coreProps={{ id: MODAL_IDS.COMPLETE_SIGN_UP }}
    contentClassName="border-0 complete-profile-modal overflow-hidden bg-dark-blue"
    fade
  >
    <FormCompleteSignUp coreProps={{ ...(userData?.mobilePhone && { notEditableFields: ['mobile'] }) }} />
  </ModalWindow>
);

CompleteSignUpModalUI.propTypes = {
  userData: PropTypes.shape().isRequired,
};

export const CompleteSignUpModal = withUser(
  CompleteSignUpModalUI
);
